import { useEffect, useRef } from 'react';
import elevenLabsService from '../services/elevenLabsService';

export const useAuraVoice = (text, context = 'default') => {
  const audioRef = useRef(null);

  useEffect(() => {
    if (!text) return;

    const playAudio = async () => {
      try {
        const audioUrl = await elevenLabsService.generateSpeech(text, context);
        
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current = null;
        }
        
        audioRef.current = new Audio(audioUrl);
        await audioRef.current.play();
      } catch (err) {
        console.error('TTS Error:', err);
      }
    };

    playAudio();

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, [text, context]);
};